import angular from 'angular';
import goalSetterSidebar from './goalSetterSidebar';

export default angular
  .module('components.goalSetterSidebar', [])
  .component('goalSetterSidebar', goalSetterSidebar).name;
